export default "__VITE_ASSET__g3S2hbK2__"